import { render, staticRenderFns } from "./MailSettings.vue?vue&type=template&id=3ed18416&"
import script from "./MailSettings.vue?vue&type=script&lang=js&"
export * from "./MailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports